<!--
    描述：标签管理 --- 标签维护
    时间：2021-01-15
    Created by ws
-->
<template>
	<div class="operation-layout pd0">
		<!-- 列表查询页 -->
		<filter-layout @search="doSearch" @reset="doRefresh" hasMore>
			<template #filter>
				<el-form class="flex-row-form colspan-4" size="small" ref="searchRef" :model="searchForm" label-width="120px">
					<el-form-item label="标签名称：" prop="sname">
						<el-input v-model="searchForm.sname" placeholder="请输入" size="small"></el-input>
					</el-form-item>
					<el-form-item label="标签类型：" prop="type">
						<el-select v-model="searchForm.type" size="small">
							<el-option value="" label="全部"></el-option>
							<el-option :value="0" label="个人"></el-option>
							<el-option :value="1" label="公共"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="创建人：" prop="createUser">
						<el-input v-model="searchForm.createUser" placeholder="请输入" size="small"></el-input>
					</el-form-item>
					<el-form-item label="业务板块：" prop="busUnit">
						<el-select v-model="searchForm.busUnit" placeholder="请选择业务板块" size="small">
							<el-option v-for="(item, index) in systemArr" :key="'yewu' + index" :label="item.label" :value="item.value"></el-option>
						</el-select>
					</el-form-item>
				</el-form>
			</template>
			<template #more>
				<el-form class="flex-row-form colspan-4" size="small" ref="searchRef" :model="searchForm" label-width="120px">
					<el-form-item label="标签对象：" prop="applys" class="w50">
						<el-select v-model="searchForm.applys">
							<el-option v-for="(item, index) in tagsArr" :key="'TAG' + index" :label="item.label" :value="item.value"></el-option>
						</el-select>
					</el-form-item>
				</el-form>
			</template>
			<template #content>
				<!-- 非请求参数 正常查看 -->
				<div class="operation-main">
					<div class="operation-header">
						<div class="left-btn"></div>
						<div class="btnGroups">
							<el-button v-if="roleBtns.includes('tagMaintenance-add')" class="btn-success" size="small" @click="handleShow('add')"
								>新增</el-button
							>
						</div>
					</div>
					<div class="operation-container w-table-layout w-table-page">
						<div class="w-table-content" v-show="tableShow">
							<vxe-table
								ref="xTable"
								:data="tableObj.tableData"
								highlight-current-row
								highlight-hover-row
								align="center"
								border
								height="100%"
								size="small"
								auto-resize
								resizable
								show-overflow="tooltip"
								show-header-overflow="tooltip"
							>
								<vxe-table-column type="seq" title="序号" width="55px"></vxe-table-column>
								<vxe-table-column field="sname" title="标签名称" min-width="185px"></vxe-table-column>
								<vxe-table-column field="type" title="标签类型" width="185px">
									<template v-slot="{ row }">
										<span>{{ row.type === 1 ? '公共标签' : '个人标签' }}</span>
									</template>
								</vxe-table-column>
								<vxe-table-column field="applysName" title="标签对象" min-width="185px"></vxe-table-column>
								<vxe-table-column field="busUnitName" title="业务板块" width="185px"></vxe-table-column>
								<vxe-table-column field="createUser" title="创建人" width="150px"> </vxe-table-column>
								<vxe-table-column field="createDate" title="创建时间" width="180px"></vxe-table-column>
								<vxe-table-column field="status" title="标签状态" width="110px">
									<template v-slot="{ row }">
										<vxe-switch
											:value="row.status"
											open-label="启用"
											:open-value="1"
											close-label="禁用"
											:close-value="0"
											:class="{
												opacityHide: !roleBtns.includes('tagMaintenance-enable')
											}"
											@click.native.prevent="changeState(row)"
										></vxe-switch>
									</template>
								</vxe-table-column>
								<vxe-table-column title="操作" width="160px">
									<template v-slot="{ row }">
										<el-button
											class="table-btn"
											type="success"
											round
											plain
											size="small"
											:disabled="row.type === 0"
											v-if="roleBtns.includes('tagMaintenance-edit')"
											@click="handleShow('edit', row)"
										>
											<svg-icon icon-class="form-edit"></svg-icon> 编辑
										</el-button>
										<el-button
											type="danger"
											size="small"
											round
											plain
											class="table-btn"
											icon="el-icon-delete"
											:disabled="row.type === 0"
											v-if="roleBtns.includes('tagMaintenance-del')"
											@click="doDelete(row)"
											>删除</el-button
										>
									</template>
								</vxe-table-column>
							</vxe-table>
						</div>
						<div class="w-table-footer">
							<el-pagination
								@size-change="handleSizeChange"
								@current-change="handleCurrentChange"
								:current-page="tableObj.currentPage"
								:page-size="tableObj.pageSize"
								:page-sizes="[10, 20, 50, 100]"
								layout="total, sizes, prev, pager, next, jumper"
								:total="tableObj.total"
							>
							</el-pagination>
						</div>
					</div>
				</div>
			</template>
		</filter-layout>

		<!-- 新增、编辑弹窗 -->
		<el-dialog
			:visible.sync="dialogObj.visible"
			:title="dialogObj.title"
			:width="dialogObj.width"
			class="primary-dialog"
			:close-on-click-modal="false"
			@closed="handleClosed"
			center
		>
			<el-form label-width="110px" :model="formObj" :rules="formRules" :show-message="false" ref="formObj">
				<el-form-item label="业务板块：" prop="busUnit">
					<el-select v-model="formObj.busUnit" placeholder="请选择业务板块" size="small">
						<el-option v-for="(item, index) in systemArr" :key="'add-yewu' + index" :label="item.label" :value="item.value"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="标签对象：" prop="applys">
					<el-radio-group v-model="formObj.applys">
						<el-radio v-for="(item, index) in tagsArr" :key="'add-TAG' + index" :label="item.value">{{ item.label }}</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="标签名：" prop="sname">
					<el-input placeholder="请输入" v-model="formObj.sname" :maxlength="20" show-word-limit></el-input>
				</el-form-item>
			</el-form>

			<!-- footer 组件 -->
			<div slot="footer" class="pdb10 text-center">
				<el-button size="small" class="btn" @click="dialogObj.visible = false">取 消 </el-button>
				<el-button type="primary" size="small" class="btn btn-blue" @click="doSubmit">确 定 </el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import { mapState } from 'vuex'
import { getDict, getTagsList, saveOrUpdate, deleteTag, setTagFlag } from 'api/modules/tag_management'

export default {
	data() {
		return {
			searchToggle: true, // 切换展示 筛选条件
			tableShow: true, // 展示表格
			// 查询条件
			searchForm: {
				sname: '', // 标签名称
				type: '', // 标签类型 （0个人、1公共）
				createUser: '', // 创建人
				busUnit: '', // 业务板块
				applys: '' // 标签对象
			},
			// 新增、编辑弹窗
			formObj: {
				busUnit: '',
				applys: '',
				sname: ''
			},
			formRules: {
				busUnit: [{ required: true, trigger: 'change', message: '' }],
				applys: [{ required: true, trigger: 'change', message: '' }],
				sname: [{ required: true, trigger: 'blur', message: '' }]
			},
			// 表格参数
			tableObj: {
				tableData: [],
				currentPage: 1,
				pageSize: 10,
				total: 0
			},
			// 弹窗对象
			dialogObj: {
				visible: false,
				title: '',
				width: '700px',
				type: ''
			},
			// 码表数组
			systemArr: [], // 业务板块
			tagsArr: [] // 标签对象
		}
	},
	created() {
		this.getDictList()
		this.doSearch()
	},
	methods: {
		// 获取码表
		getDictList() {
			getDict({ value: '1001025' })
				.then((res) => {
					if (res.operationCode === 1) {
						this.systemArr = res.data
					}
				})
				.catch((err) => {})
		},

		// 查询
		doSearch(page) {
			if (page) {
				this.tableObj.currentPage = page
			}
			let params = {
				current: this.tableObj.currentPage,
				size: this.tableObj.pageSize,
				sname: this.searchForm.sname, // 标签名称
				type: this.searchForm.type, // 标签类型（0个人、1公共）
				createUser: this.searchForm.createUser, // 创建人
				busUnit: this.searchForm.busUnit, // 业务板块码表值
				applys: this.searchForm.applys // 标签对象码表值
			}
			getTagsList(params)
				.then((res) => {
					if (res.operationCode === 1) {
						this.tableObj.tableData = res.data.records
						this.tableObj.total = parseInt(res.data.total)
					}
				})
				.catch((err) => {})
		},

		// 新增、编辑 --- 开启弹窗
		handleShow(type, row) {
			this.dialogObj.visible = true
			this.dialogObj.title = type === 'add' ? '新增' : '编辑'
			this.dialogObj.type = type

			// 编辑模式 回显
			if (type === 'edit') {
				this.formObj.sname = row.sname
				this.formObj.id = row.id
				this.formObj.busUnit = row.busUnit
				setTimeout(() => {
					this.formObj.applys = row.applys
				}, 100)
			}
		},

		// 关闭弹窗事件
		handleClosed() {
			this.$refs.formObj.resetFields()
		},

		// 切换标签状态（启用、禁用）
		changeState(row) {
			if (this.roleBtns.includes('tagMaintenance-enable')) {
				let _flag = row.status == 0 ? 1 : 0
				this.$confirm('此操作将改变该标签的状态, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				})
					.then(() => {
						let params = {
							id: row.id,
							status: _flag,
							type: row.type,
							applys: row.applys,
							busUnit: row.busUnit
						}
						setTagFlag(params)
							.then((res) => {
								if (res.operationCode === 1) {
									this.$message.success('设置成功！')
									this.doSearch()
								}
							})
							.catch((err) => {})
					})
					.catch(() => {
						this.$message.info('已取消操作！')
					})
			} else {
				this.$message.warning('当前账号没权限进行此操作！')
			}
		},

		// 确认添加、保存
		doSubmit() {
			let sname = this.formObj.sname.replace(/\s+/, '')
			this.$refs.formObj.validate((valid) => {
				if (valid && sname !== '') {
					let params = {
						sname: this.formObj.sname.trim(),
						busUnit: this.formObj.busUnit,
						applys: this.formObj.applys,
						totalCounts: '',
						applyCounts: ''
					}
					// 编辑 + id
					if (this.dialogObj.type === 'edit') {
						params.id = this.formObj.id
					}
					saveOrUpdate(params)
						.then((res) => {
							if (res.operationCode === 1) {
								this.$message.success('保存成功！')
								this.dialogObj.visible = false
								this.doSearch()
							}
						})
						.catch((err) => {})
				}
			})
		},

		// 点击删除
		doDelete(row) {
			// 启用时不允许删除
			// if (row.isFlag === 1) {
			//     this.$message.warning("标签为启用状态，不允许删除！");
			//     return;
			// }

			this.$confirm('确认删除该公共标签么?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(() => {
					deleteTag({ id: row.id })
						.then((res) => {
							if (res.operationCode === 1) {
								this.$message({
									type: 'success',
									message: '删除成功!'
								})
								this.doSearch()
							} else {
								this.$message.warning(res.msg)
							}
						})
						.catch((err) => {})
				})
				.catch(() => {})
		},

		// 点击刷新、重置
		doRefresh() {
			this.tableObj.currentPage = 1
			this.tableObj.pageSize = 10
			this.$refs.searchRef.resetFields()
			this.doSearch()
		},

		// 表格 每页条数切换
		handleSizeChange(size) {
			this.tableObj.pageSize = size
			this.doSearch()
		},

		// 表格 页码切换
		handleCurrentChange(cur) {
			this.tableObj.currentPage = cur
			this.doSearch()
		}
	},
	computed: {
		...mapState('dict', {
			ywbk: (state) => state.projectDict.xtbq // 系统标签（业务板块）
		}),
		...mapState('menu', {
			roleBtns: (state) => state.roleBtns
		}),

		// 根据标签 筛选的 标签对象
		tagObjList() {
			if (!this.ywbk) {
				return []
			}

			let obj = this.ywbk.find((x) => x.value === this.formObj.value1)

			if (obj) {
				return obj.children
			} else {
				return []
			}
		}
	},
	watch: {
		// 监听 筛选元素的 切换展示 重新调整表格高度
		searchToggle() {
			this.tableShow = false
			setTimeout(() => {
				this.tableShow = true
			}, 50)
		},

		// 业务板块
		'searchForm.busUnit': {
			handler: function(val) {
				// 清空选择
				this.searchForm.applys = ''

				if (val && val !== '') {
					let _item = this.systemArr.find((x) => x.value === val)
					_item ? (this.tagsArr = _item.children) : []
				} else {
					this.tagsArr = []
				}
			},
			deep: true
		},

		// 业务板块
		'formObj.busUnit': {
			handler: function(val) {
				// 清空选择
				this.formObj.applys = ''

				if (val && val !== '') {
					let _item = this.systemArr.find((x) => x.value === val)
					_item ? (this.tagsArr = _item.children) : []
				} else {
					this.tagsArr = []
				}
			},
			deep: true
		}
	}
}
</script>

<style scoped lang="less">
/deep/ .primary-dialog .el-dialog__body {
	padding: 20px;
}
.vxe-switch.is--disabled {
	opacity: 1;
	/deep/ .vxe-switch--button {
		cursor: pointer !important;
	}
}
/deep/ .is--on {
	.vxe-switch--button {
		background-color: #2671cc !important;
	}
}
</style>
